export default "__VITE_ASSET__Dg62$Q19__"